module.exports = __webpack_public_path__ + "static/media/figma.05d3f684.svg";